import FormField from './field.js';
import RecaptchaHelper from '../../utils/recaptcha-helper.js';

export default class Recaptcha extends FormField {
    constructor(parent, el) {
        super(parent, el);
        this.container = el.querySelector('.recaptcha-container');
        this.sitekey = el.dataset.sitekey;
        this.load();
        this.bind();
    }

    bind() {
        this.parent.addEventListener('onSuccess', () => {
            RecaptchaHelper.reset(this.widgetId);
            this.el.dataset.captcha = "true";
        });
        this.parent.addEventListener('onError', () => RecaptchaHelper.reset(this.widgetId));
    }

    async load() {
        await RecaptchaHelper.loaded();
        this.widgetId = RecaptchaHelper.render(this.container, this.sitekey, this.callback.bind(this));
    }

    callback() {
        this.update();
        this.el.dataset.captcha = "true";
    }

    static is(el) {
        return super.is(el) && el.classList.contains('form_field_recaptcha');
    }
}
